var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobSearchStrategies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42957 14.2C11.6715 14.2 14.2996 11.5719 14.2996 8.32996C14.2996 5.08805 11.6715 2.45996 8.42957 2.45996C5.18766 2.45996 2.55957 5.08805 2.55957 8.32996C2.55957 11.5719 5.18766 14.2 8.42957 14.2Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5791 12.4697L15.9691 15.8597",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 6.37988H5.91996C5.52784 6.37988 5.20996 6.69776 5.20996 7.08988V10.2899C5.20996 10.682 5.52784 10.9999 5.91996 10.9999H10.93C11.3221 10.9999 11.64 10.682 11.64 10.2899V7.08988C11.64 6.69776 11.3221 6.37988 10.93 6.37988Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71973 8.68994H9.13973",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38965 6.37973V4.96973H9.46965V6.37973",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 19.0801H8.63965V21.5401H11.0996V19.0801Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6501 13.9702L17.8701 17.0502H21.4401L19.6501 13.9702Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6502 17.0503C19.6502 19.5303 17.6402 21.5403 15.1602 21.5403",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7798 12.1298C20.6192 12.1298 21.2998 11.4493 21.2998 10.6098C21.2998 9.77037 20.6192 9.08984 19.7798 9.08984C18.9403 9.08984 18.2598 9.77037 18.2598 10.6098C18.2598 11.4493 18.9403 12.1298 19.7798 12.1298Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSearchStrategies);
export default __webpack_public_path__ + "static/media/Job Search Strategies.2baa71c9f9b7a6e9f8ca2fe846b56e59.svg";
export { ForwardRef as ReactComponent };